export enum ProjectState {
  Sandbox = 0,
  Proposed = 1,
  Active = 7,
}

export const projectStateAsString = new Map([
  [ProjectState.Sandbox, "Sandbox"],
  [ProjectState.Proposed, "Proposed"],
  [ProjectState.Active, "Active"],
]);

export const getProjectStateDisplayName = (state: ProjectState | undefined) => {
  return state !== undefined ? ProjectState[state] : "";
};
